import { useMemo } from "react";

import useQuery from "hooks/useQuery";

// El listado de resources del team devuelve el doc completo de cada profesional,
// así que de ahí salen las notas internas. Los facets de availability no las traen.
const useInternalNotes = (enabled = true) => {
  const endpoint = enabled ? window._l("/resources").substr(1) : null;
  const query = useQuery(endpoint, { enabled: !!endpoint, initialData: [] });

  return useMemo(() => {
    const notes = {};
    for (const resource of query.data || []) {
      const note = (resource?.internalNote || "").trim();
      if (!note || !resource.id) continue;
      // Los facets de availability usan claves "resources/<id>" pero el listado
      // del team puede traer el id con o sin ese prefijo. Se indexa bajo las dos
      // formas para que todos los consumidores resuelvan con un lookup directo
      // y no puedan divergir en cómo hacen el match.
      const bareID = String(resource.id).replace(/^resources\//, "");
      notes[bareID] = note;
      notes[`resources/${bareID}`] = note;
    }
    return notes;
  }, [query.data]);
};

export default useInternalNotes;
